/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  ItemListResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary get matched MDT items
 */
export const getMatchedMdtItem = (itemName: string, signal?: AbortSignal) => {
  return customInstance<ItemListResponseResponse>({
    url: `/BboBranchConfigService/v1/forex-metadata/${itemName}`,
    method: 'get',
    signal,
  });
};

export const getGetMatchedMdtItemQueryKey = (itemName: string) => {
  return [`/BboBranchConfigService/v1/forex-metadata/${itemName}`] as const;
};

export const getGetMatchedMdtItemQueryOptions = <
  TData = Awaited<ReturnType<typeof getMatchedMdtItem>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  itemName: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchedMdtItem>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMatchedMdtItemQueryKey(itemName);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchedMdtItem>>> = ({ signal }) =>
    getMatchedMdtItem(itemName, signal);

  return { queryKey, queryFn, enabled: !!itemName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMatchedMdtItem>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMatchedMdtItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMatchedMdtItem>>
>;
export type GetMatchedMdtItemQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary get matched MDT items
 */
export const useGetMatchedMdtItem = <
  TData = Awaited<ReturnType<typeof getMatchedMdtItem>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  itemName: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchedMdtItem>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMatchedMdtItemQueryOptions(itemName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
